"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_SAMPLE_VALUE = 1;
var BasePlugin = (function () {
    function BasePlugin(configs) {
        this.type = 'base';
        this.offsetByte = undefined;
        this.triggerHandler = function (data) {
        };
        this.delegateReporter = false;
        this.sample = DEFAULT_SAMPLE_VALUE;
        this.enable = true;
        this.configs = configs !== null && configs !== void 0 ? configs : {};
        this.sample = this.defaultSample;
    }
    BasePlugin.prototype.serverNow = function (timestamp) {
        return new Date().getTime();
    };
    Object.defineProperty(BasePlugin.prototype, "defaultSample", {
        get: function () {
            var configs = this.configs;
            var hasValidSampleConfig = typeof (configs === null || configs === void 0 ? void 0 : configs['sample']) === 'number' &&
                (configs === null || configs === void 0 ? void 0 : configs['sample']) >= 0 &&
                (configs === null || configs === void 0 ? void 0 : configs['sample']) <= 1;
            if (hasValidSampleConfig) {
                return configs === null || configs === void 0 ? void 0 : configs['sample'];
            }
            return DEFAULT_SAMPLE_VALUE;
        },
        enumerable: false,
        configurable: true
    });
    BasePlugin.prototype.register = function (props) {
        this.triggerHandler = props.trigger;
    };
    BasePlugin.prototype.unregister = function (de_app_id) {
        this.triggerHandler = function () {
        };
    };
    return BasePlugin;
}());
exports.default = BasePlugin;
